import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from './models/configuration';
import { Notification } from './models/notification';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FcmPushService {

  private readonly baseUrl = 'https://fcm.googleapis.com/fcm';

  constructor(@Inject('config') private config: Configuration,
    private httpClient: HttpClient) {
  }

  sendTopicNotification(notificationBody: Notification): Observable<Object> {
    const notification = {
      data: {
        landing_page: notificationBody.landing_page,
        message: notificationBody.body,
      },
      notification: {
        body: notificationBody.body,
        click_action: notificationBody.click_action,
        icon: notificationBody.icon,
        sound: 'default',
        title: notificationBody.title,
      },
      priority: 'high',
      to: `/topics/${notificationBody.topic}`
    };

    return this.httpClient.post(`${this.baseUrl}/send`, notification, {
      headers: {
        Authorization: `key=${this.config['token']}`,
        'Content-Type': 'application/json'
      }
    });
  }

  sendPersonalNotification(fcmToken: string, notificationBody: Notification): Observable<Object> {
    const notification = {
      data: {
        landing_page: notificationBody.landing_page,
        message: notificationBody.body,
      },
      notification: {
        body: notificationBody.body,
        click_action: notificationBody.click_action,
        icon: notificationBody.icon,
        sound: 'default',
        title: notificationBody.title,
      },
      priority: 'high',
      to: `/${fcmToken}`
    };

    return this.httpClient.post(`${this.baseUrl}/send`, notification, {
      headers: {
        Authorization: `key=${this.config['token']}`,
        'Content-Type': 'application/json'
      }
    });
  }
}
